import { gql } from '@apollo/client';

export const getPolicyMotorDetailsQuery = gql`
  query getPolicyMotorDetails($policyId: String!) {
    Production {
      queries {
        getPolicyMotorDetails(selectedPolicyID: $policyId, state: LATEST) {
          production_PolicyMotor_Id
          production_PolicyMotor_NameOnLicenseEn
          production_PolicyMotor_NameOnLicenseAr
          production_PolicyMotor_VignetteCode
          production_PolicyMotor_Vignette
          vehicle_PlateCode {
            Id
            Code
            Title
          }
          vehicle_PlateNumber
          vehicle_UsageType {
            Id
            Code
            Title
          }
          vehicle_BodyType {
            Id
            Code
            Title
          }
          vehicle_EngineType {
            Id
            Code
            Title
          }
          vehicle_Make {
            Id
            Code
            Title
          }
          vehicle_Model {
            Id
            Code
            Title
          }
          vehicle_Color {
            Id
            Code
            Title
          }
          vehicle_YearOfMake
          vehicle_Engine
          vehicle_Weight
          vehicle_EngineSize
          vehicle_SeatingCapacity
          vehicle_Chassis
          vehicle_HorsePower
          vehicle_CarValue
          production_PolicyMotor_AgencyRepairYear
          production_PolicyMotor_DepreciationYears
        }
      }
    }
    Core {
      lookups {
        colors {
          Id
          Code
          Title
        }
      }
    }
    Insurance {
      lookups {
        plateCodes {
          Id
          Code
          Title
        }
        usageTypes {
          Id
          Code
          Title
        }
        bodyTypes {
          Id
          Code
          Title
        }
        engineTypes {
          Id
          Code
          Title
        }
        brands {
          Id
          Code
          Title
        }
      }
    }
  }
`;
